import { makeSelectors } from '@utils/css';
import { wrapper } from './option.style.js';

const list = "dibl1577q47";
const legend = "diblri5niv";
const noMatches = "dibnu3drit";
const listboxSelectors = makeSelectors({
  option: wrapper
});

export { legend, list, listboxSelectors, noMatches };
import "./_listbox.style.linaria.module.css";
//# sourceMappingURL=_listbox.style.js.map
